import { Modal, Text } from "components/common"
import { t } from "i18next"
import { forwardRef } from "react"

const ConfirmationModal = forwardRef((props, ref) => {
  const { title, onOk, loading, confirmationText } = props

  return (
    <Modal
      okText={t("Yes")}
      cancelText={t("No")}
      onOk={onOk}
      onCancel={() => {
        ref?.current.setVisible(false)
      }}
      ref={ref}
      title={title}
      width={500}
      loading={loading}
    >
      <Text>{confirmationText}</Text>
    </Modal>
  )
})

export default ConfirmationModal
